const defaultUserContext: any = [{}];

export default defaultUserContext;
